import * as Yup from 'yup';

import { buildWebhookCredentialsSchema } from './webhookCredentialsSchema';

interface IFormSchemaOptions {
  originalAuthType?: string;
}

export const buildWebhookFormSchema = (options?: IFormSchemaOptions) =>
  buildWebhookCredentialsSchema(options).concat(
    Yup.object({
      url: Yup.string()
        .url('Must be a valid URL')
        .matches(/https:\/\/.*$/, 'URL must start with https://')
        .required('URL is required'),
    })
  );
